module.exports = require("@fullcalendar/timegrid");